'use client';
// Libs
import { Stack, Typography, useMediaQuery, useTheme } from 'ui-components';
import { PageHeaderProps } from './page-header.interfaces';
import User from './user';

export default function PageHeader(props: PageHeaderProps) {
  const { title, actions } = props;
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Stack direction="row" justifyContent="space-between">
      <Typography variant="h1" fontWeight="700" fontSize="2rem">
        {title}
      </Typography>
      {!isSmallScreen && (
        <Stack justifyContent="flex-end" minWidth={150} minHeight={46}>
          <User />
        </Stack>
      )}
      {actions}
    </Stack>
  );
}
